import { observable, action, computed } from 'mobx';
import { fromPromise } from 'mobx-utils';
import RemoteUserMediaStore from './RemoteUserMediaStore';

class ParticipantsStore {
  @observable.ref participantMedias = [];

  constructor(store) {
    this.store = store;
  }

  @computed
  get teacherMedia() {
    const teacherId = this.store.room.createdBy;
    return this.participantMedias.find(p => p.userId === teacherId);
  }

  @computed
  get learnerMedias() {
    const teacherId = this.store.room.createdBy;
    return this.participantMedias.filter(p => p.userId !== teacherId);
  }

  @computed
  get totalLearners() {
    return this.learnerMedias.length;
  }

  @computed
  get learnerUsers() {
    const promise = Promise.all(this.learnerMedias.map(m => m.user));
    return fromPromise(promise);
  }

  @computed
  get totalMembers() {
    const teacherCount = this.teacherMedia ? 1 : 0;
    return this.totalLearners + teacherCount;
  }

  @action
  initParticipants = (participants, twilioRoom) => {
    this.participantMedias.map(p => p.handleRoomDisconnect());
    this.participantMedias = [];
    Array.from(participants.values()).forEach((p) => {
      const media = new RemoteUserMediaStore(this.store);
      media.initUserMedia(p, twilioRoom);
      media.sync({ userId: p.identity });
      this.participantMedias.push(media);
    });

    twilioRoom
      .off('disconnected', this.handleRoomDisconnect)
      .on('disconnected', this.handleRoomDisconnect);

    twilioRoom
      .off('participantConnected', this.handleParticipantConnected)
      .on('participantConnected', this.handleParticipantConnected)
      .off('participantDisconnected', this.handleParticipantDisconnected)
      .on('participantDisconnected', this.handleParticipantDisconnected);
  };

  @action
  handleParticipantConnected = (participant) => {
    const identity = participant.identity;
    const participantMedia = this.participantMedias.find(p => p.userId === identity);
    const room = this.store.room.twilioRoom;
    if (participantMedia) {
      participantMedia.initUserMedia(participant, room);
    } else {
      const media = new RemoteUserMediaStore(this.store);
      media.initUserMedia(participant, room);
      media.sync({ userId: identity });
      this.participantMedias = [...this.participantMedias, media];
      if (this.participantMedias.length === 1) {
        this.store.membersDrawer.showDrawer();
      }
    }
  };

  @action
  handleParticipantDisconnected = (participant) => {
    const identity = participant.identity;
    const participantMedia = this.participantMedias.find(p => p.userId === identity);
    if (participantMedia) {
      participantMedia.handleRoomDisconnect();
      this.participantMedias = this.participantMedias.filter(p => p.userId !== identity);
    }
  };

  // Release resources
  handleRoomDisconnect = () => {
    this.participantMedias.map(p => p.handleRoomDisconnect());
    this.participantMedias = [];
  };
}

export default ParticipantsStore;
